var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/small 12px Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-a-kit_Insights_Fb_Feed-",
    transform: "translate(-40.000000, -1120.000000)",
    stroke: "#111111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module/overall-",
    transform: "translate(20.000000, 1007.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Insights/Reach",
    transform: "translate(20.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tool-hand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,3.5 L7.5,3 C7.5,2.17157288 6.82842712,1.5 6,1.5 L6,1.5 C5.17157288,1.5 4.5,2.17157288 4.5,3 L4.5,9.5 L2.179,8.587 C1.73098653,8.40920476 1.2201674,8.51451209 0.879,8.855 L0.879,8.855 C0.428380667,9.30385869 0.40259073,10.0251027 0.82,10.505 L3.439,13.405 C4.60335238,14.7383566 6.28681493,15.5038983 8.057,15.505 L9.364,15.505 C10.9922351,15.505 12.5537089,14.8578447 13.7045759,13.7060398 C14.855443,12.5542349 15.5013268,10.9922345 15.500002,9.364 L15.500002,3.5 C15.500002,2.94771525 15.0522847,2.5 14.5,2.5 L14.5,2.5 C13.9477153,2.5 13.5,2.94771525 13.5,3.5 L13.5,4.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,3.5 L10.5,3 C10.5,2.17157288 11.1715729,1.5 12,1.5 L12,1.5 C12.8284271,1.5 13.5,2.17157288 13.5,3 L13.5,6.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,6.5 L7.5,2 C7.5,1.17157288 8.17157288,0.5 9,0.5 L9,0.5 C9.82842712,0.5 10.5,1.17157288 10.5,2 L10.5,6.5",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReach);
export default __webpack_public_path__ + "static/media/reach.fd8045159828fb588cb790726bfde0b2.svg";
export { ForwardRef as ReactComponent };